import { FunctionComponent, memo } from "react";
import { BarChart, Bar, ResponsiveContainer, Cell, Tooltip } from "recharts";
import BasicChartTooltip from "../../charts/basic-chart-tooltip";
import { IProps } from "./metric-frequency-chart.types";
import "./metric-frequency-chart.scss";

/**
 * Metric frequency chart. Display a histogram chart based on the
 * number of interactions availble in a rangle sample
 * @param props.metricData          Data used for ploting the chart
 */
const MetricFrequencyChart: FunctionComponent<IProps> = ({ metricData }) => {
    return (
        <ResponsiveContainer height={150} width={"100%"} className="metric-frequency-chart">
            <BarChart data={metricData}>
                <Bar dataKey="frequency">
                    {metricData.map((_, index) => (
                        <Cell
                            cursor="pointer"
                            key={`cell-${index}`}
                            radius={2}
                            className="metric-frequency-chart__bar"
                        />
                    ))}
                </Bar>
                <Tooltip
                    isAnimationActive={false}
                    content={({ active, payload }) =>
                        active &&
                        Array.isArray(payload) &&
                        typeof payload[0].value === "number" && (
                            <BasicChartTooltip frequency={payload[0].payload.frequency} label="interactions" />
                        )
                    }
                />
            </BarChart>
        </ResponsiveContainer>
    );
};

export default memo(MetricFrequencyChart);
